
import LanguageSelect from "@/components/LanguageSelect.vue";
import { apiCall } from "@/lib/api";
import { Component, MixedVue } from "@/vue";
import { Watch } from "vue-property-decorator";

@Component({
  name: "AlcedoLanding",
  components: {
    LanguageSelect: LanguageSelect,
  },
})
export default class AlcedoLanding extends MixedVue {
  static components: {
    LanguageSelect: typeof LanguageSelect;
  };

  errors = {
    error: "",
    email: "",
    first_name: "",
    last_name: "",
    phone: "",
    password1: "",
  };
  email = "";
  first_name = "";
  last_name = "";
  phone = "";
  password1 = "";
  generaltos = false;
  marketing = false;

  showPassword = false;
  isLoading = false;

  get formValid() {
    return this.email && this.first_name && this.last_name && this.phone && this.password1 && this.generaltos;
  }

  get user() {
    return this.$store.getters.user;
  }

  async submitForm() {
    if (!(await this.validateForm())) return;
    try {
      this.isLoading = true;
      await apiCall(
        "POST",
        "/auth/registration/",
        {},
        {
          email: this.email,
          first_name: this.first_name,
          last_name: this.last_name,
          phone: this.phone,
          password1: this.password1,
          password2: this.password1,
          privacy: true,
          generaltos: true,
          marketing: this.marketing,
          preferred_language: this.$language.current.toUpperCase(),
          campaign: "my-alcedo-soil",
        }
      );
      this.$store.commit("setAttemptedLogin", {
        email: this.email,
        newUser: true,
      });
      this.$router.push({ name: "email-confirmation" });
    } catch (e) {
      this.setErrors(e);
    } finally {
      this.isLoading = false;
    }
  }

  mounted() {
    this.maybeRedirect();
  }

  @Watch("user")
  async maybeRedirect() {
    if (!this.user.id) return;
    await this.$store.dispatch("getFarms");
    const farmId = this.$store.getters.managedFarms.filter((farm) => farm.hasSeasons)[0]?.id;
    if (!farmId) {
      this.$router.replace({ name: "redirect" });
      return;
    }
    window.location.href = `/myalcedosoil/${farmId}/`;
  }

  async validateForm() {
    this.clearErrors();
    if (!this.phone.match(/^\+?\d{8,14}$/)) {
      this.errors.phone = this.$gettext("Please enter a valid phone number.");
      return false;
    }
    if (this.password1.length < 5) {
      this.errors.password1 = this.$gettext("The password is too short. It must contain at least 5 characters.");
      return false;
    }
    try {
      this.isLoading = true;
      const email = this.email;
      if (
        !email
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          )
      )
        throw "";
      await apiCall("POST", "/validate-email/", {}, { email });
      return true;
    } catch (err) {
      this.errors.email = " ";
      this.errors.error = this.$gettext("We can't create an account with this email address.");
      return false;
    } finally {
      this.isLoading = false;
    }
  }
}
